import Link from '@material-ui/core/Link';
import { IManual } from 'interfaces/manual';
import React, { memo } from 'react';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import { dateFormat } from 'formatters/date';

interface IProps {
  manual: IManual;
}

const ListItem = (props: IProps) => {
  const { manual } = props;

  return (
    <TableRow>
      <TableCell>
        <Link
          target="_blank"
          rel="noopener noreferrer"
          href={manual.url}
        >
          {manual.name && manual.name}
        </Link>
      </TableCell>
      <TableCell align="right">
        {manual.createdDate ? dateFormat(new Date(manual.createdDate)) : '-'}
      </TableCell>
    </TableRow>
  );
};

export default memo<IProps>(ListItem);